/* eslint-disable no-shadow */

export enum EnforceabilityEnum {
  EXIGIVEL = 1,
  NAO_INCIDENCIA = 2,
  ISENCAO = 3,
  EXPORTACAO = 4,
  IMUNIDADE = 5,
  SUSPENSO_POR_ACAO_JUDICIAL = 6,
  SUSPENSO_POR_ACAO_ADMINISTRATIVA = 7,
}

export const EnforceabilityLabels: Record<number, string> = {
  [EnforceabilityEnum.EXIGIVEL]: "Exigível",
  [EnforceabilityEnum.NAO_INCIDENCIA]: "Não Incidência",
  [EnforceabilityEnum.ISENCAO]: "Isenção",
  [EnforceabilityEnum.EXPORTACAO]: "Exportação",
  [EnforceabilityEnum.IMUNIDADE]: "Imunidade",
  [EnforceabilityEnum.SUSPENSO_POR_ACAO_JUDICIAL]: "Suspenso por Ação Judicial",
  [EnforceabilityEnum.SUSPENSO_POR_ACAO_ADMINISTRATIVA]:
    "Suspenso por Ação Administrativa",
};

export const EnforceabilityList = [
  EnforceabilityEnum.EXIGIVEL,
  EnforceabilityEnum.NAO_INCIDENCIA,
  EnforceabilityEnum.ISENCAO,
  EnforceabilityEnum.EXPORTACAO,
  EnforceabilityEnum.IMUNIDADE,
  EnforceabilityEnum.SUSPENSO_POR_ACAO_JUDICIAL,
  EnforceabilityEnum.SUSPENSO_POR_ACAO_ADMINISTRATIVA,
].map((value) => ({ value, label: EnforceabilityLabels[value] }));

// ISS é zerado automaticamente quando hasForeignService=true e exigibilidade ∈ {2,3,4}.
export const ENFORCEABILITY_ZERO_ISS = [
  EnforceabilityEnum.NAO_INCIDENCIA,
  EnforceabilityEnum.ISENCAO,
  EnforceabilityEnum.EXPORTACAO,
];
